var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-sign" },
    [
      _c("p", [
        _vm._v(
          "Guten Tag " + _vm._s(_vm.data.vorname) + " " + _vm._s(_vm.data.name)
        )
      ]),
      _vm._m(0),
      _c(
        "v-form",
        { ref: "sign-form", attrs: { "lazy-validation": "" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-5" },
            [
              _c(
                "v-col",
                { staticClass: "pdf-container", attrs: { cols: "12" } },
                [
                  _c("embed", {
                    class: _vm.isFirefox && "hide-top-pane",
                    attrs: { id: "pdf-view", src: _vm.pdfUrl }
                  })
                ]
              ),
              _c(
                "v-col",
                { staticClass: "mt-8", attrs: { cols: "12" } },
                [
                  _c("h3", [_vm._v("Vertrag elektronisch signieren:")]),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "Nachfolgend können Sie den Stipendienvertrag mit gedrückter linker Maustaste oder einem Touchpad-Stift digital unterzeichnen. Fehlerhafte Eingaben können über das X-Symbol am oberen rechten Rand des Unterschriftenfelds zurückgesetzt werden."
                    )
                  ]),
                  _c("n-sign-pad", {
                    ref: "sign",
                    attrs: { required: "" },
                    model: {
                      value: _vm.data.sign,
                      callback: function($$v) {
                        _vm.$set(_vm.data, "sign", $$v)
                      },
                      expression: "data.sign"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "my-8", attrs: { cols: "12" } },
                [
                  _c("p", [
                    _vm._v(
                      'Mit dem Klick auf die Schaltfläche "Vertrag absenden" wird Ihre Unterschrift an unseren Server gesendet und digital in den Vertrag eingefügt. Anschließend erhalten Sie eine von der GVL gegengezeichnete Version des Vertrags automatisch per E-Mail zugesandt.'
                    )
                  ]),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled: !_vm.pdfUrl,
                        block: ""
                      },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("Vertrag absenden")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.loading
        ? _c(
            "div",
            { staticClass: "overlay-spinner" },
            [
              _c("v-progress-circular", {
                attrs: { size: 60, color: "#ccc", indeterminate: "" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "wir freuen uns, Ihnen mitteilen zu dürfen, dass Ihr Antrag von der unabhängigen Fachjury positiv bewertet und bewilligt wurde."
      ),
      _c("br"),
      _vm._v(
        "\nNachfolgend finden Sie den für Sie vorbereiteten Stipendienvertrag."
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }